import { RECOVERY_CODE_MAX_LENGTH, TOTP_CODE_LENGTH } from '@constants/limits';
import { CODE } from '@locales/id/auth';

/** What is wrong with a typed authenticator code (null: it can be sent). */
export function codeProblem(code: string): string | null {
  if (!code) return CODE.required;
  if (code.length !== TOTP_CODE_LENGTH) return CODE.short;
  return null;
}

/** A recovery code as the person typed it, without spaces (the backend compares it without case and dashes). */
export const recoveryInput = (raw: string) => raw.replace(/\s+/g, '').slice(0, RECOVERY_CODE_MAX_LENGTH);

export const recoveryProblem = (code: string): string | null => (code ? null : CODE.recoveryRequired);

/** "ABCD EFGH IJKL …": a base32 secret in groups of four, easier to type into an app by hand. */
export const groupSecret = (secret: string) => secret.replace(/\s+/g, '').replace(/(.{4})(?=.)/g, '$1 ');
